import { useEffect, useRef } from 'react';

const AboutSection = () => {
  const imgRef = useRef<HTMLDivElement>(null);
  const imgRef2 = useRef<HTMLDivElement>(null);
  const imgRef3 = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = imgRef.current;
    if (!el) return;
    let start: number | null = null;
    let animId: number;

    const animate = (timestamp: number) => {
      if (!start) start = timestamp;
      const elapsed = timestamp - start;
      const y = Math.sin(elapsed / 600) * 10;
      el.style.transform = `translateY(${y}px)`;
      animId = requestAnimationFrame(animate);
    };

    animId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animId);
  }, []);

  useEffect(() => {
    const el = imgRef2.current;
    if (!el) return;
    let start: number | null = null;
    let animId: number;

    const animate = (timestamp: number) => {
      if (!start) start = timestamp;
      const elapsed = timestamp - start;
      const y = Math.sin(elapsed / 600 + Math.PI) * 10;
      el.style.transform = `translateY(${y}px)`;
      animId = requestAnimationFrame(animate);
    };

    animId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animId);
  }, []);

  useEffect(() => {
    const el = imgRef3.current;
    if (!el) return;
    let start: number | null = null;
    let animId: number;

    const animate = (timestamp: number) => {
      if (!start) start = timestamp;
      const elapsed = timestamp - start;
      const y = Math.sin(elapsed / 600 + Math.PI / 2) * 10;
      el.style.transform = `translateY(${y}px)`;
      animId = requestAnimationFrame(animate);
    };

    animId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animId);
  }, []);

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://mm.ai-adult.org/wp-content/uploads/2024/04/b79c434e8259536c059f477d94348472.webp"
                alt="MITUTAS"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-teal-500/10 rounded-full blur-3xl"></div>
            <div className="absolute -top-6 -left-6 w-48 h-48 bg-teal-500/10 rounded-full blur-3xl"></div>
          </div>

          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About MITUTAS
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p className="text-lg">
                <strong className="text-gray-900">釣り：</strong>
                淡水釣りから海水釣りまで、テクニック、道具のレビュー、魚の行動などを中心にカバー。
              </p>
              <p className="text-lg">
                <strong className="text-gray-900">アクアリウム：</strong>
                様々な種類の魚、水槽のメンテナンス、リラックスできる趣味としての水槽飼育の利点について学びます。
              </p>
              <p className="text-lg">
                このブログでは、釣りとアクアリウムに関する幅広い情報を提供しています。
                初心者から上級者まで、すべての方に役立つコンテンツをお届けします。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-3 gap-6">
              <div className="flex items-center justify-center p-4">
                <div ref={imgRef} className="w-full flex items-center justify-center">
                  <img
                    src="https://static.readdy.ai/image/70a4703660d18bee8c4b43bbf221e0fa/ab325a3034348193e8e430fb9c3e4bcd.svg"
                    alt="画像"
                    className="w-full h-auto max-h-24 object-contain"
                  />
                </div>
              </div>
              <div className="flex items-center justify-center p-4">
                <div ref={imgRef2} className="w-full flex items-center justify-center">
                  <img
                    src="https://static.readdy.ai/image/70a4703660d18bee8c4b43bbf221e0fa/c10423a4237c4bb34c69e5292583fa02.svg"
                    alt="画像2"
                    className="w-full h-auto max-h-24 object-contain"
                  />
                </div>
              </div>
              <div className="flex items-center justify-center p-4">
                <div ref={imgRef3} className="w-full flex items-center justify-center">
                  <img
                    src="https://static.readdy.ai/image/70a4703660d18bee8c4b43bbf221e0fa/a033eea550d896c69ea09514be01bf70.svg"
                    alt="画像3"
                    className="w-full h-auto max-h-24 object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
